import { Record } from 'immutable';
export default Record({
  serviceName: null,
  source: null
}, 'SourceApplication');